import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useParams } from "react-router-dom";
import axios from "axios";
import API_URL from "../../localhost/config"; //Importa la variable global
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ExcelJS = require("exceljs");

const notifySuccess = (mensaje) => {
  toast.success(mensaje, {
    position: "bottom-right",
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
    theme: "colored",
  });
};

const notifyWanr = (mensaje) => {
  toast.warn(mensaje, {
    position: "bottom-right",
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
    theme: "colored",
  });
};

const ModalCargaMasiva = ({ showModalCargaMasiva, quitar }) => {
  //Token
  const [token, setToken] = useState(localStorage.getItem("token"));

  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const { idTorneo } = useParams();
  const [error, setError] = useState(null);

  const colores = (texto) => {
    // if(String(cell.value).includes("No puede"))
    if (texto.includes("Prioridad Alta")) {
      return "90E56B";
    } else if (texto.includes("Prioridad Media")) {
      return "E8EE2B";
    } else if (texto.includes("Prioridad Baja")) {
      return "E79023";
    } else if (texto.includes("No Puede")) {
      return "F7573E";
    }
    return "FFFFFF";
  };

  // Función para configurar la fórmula de formato condicional en la celda

  const descargarExcel = async () => {
    try {
      await axios.get(`${API_URL}/getExcel/${idTorneo}`).then((response) => {
        const jsonData = response.data;

        //   XLSX.writeFile(libro, `datos.xlsx`);
        // Crear un nuevo libro de Excel
        const workbook = new ExcelJS.Workbook();

        // Añadir una hoja al libro
        const worksheet = workbook.addWorksheet("Hoja1");

        // Obtener las claves del primer objeto para las columnas

        const claves = Object.keys(jsonData[0]);
        const headers = claves.map((clave) => {
          return { header: clave, key: clave, width: 22 };
        });
        worksheet.columns = headers;
        jsonData.map((dato) => {
          worksheet.addRow(dato);
        });

        worksheet.getCell("A1").dataValidation = {
          type: "list",
          allowBlank: true,
          formulae: ['"One,Two,Three,Four"'],
        };

        // Iterar sobre cada fila de la hoja de trabajo
        worksheet.eachRow((row, rowIndex) => {
          // Iterar sobre cada celda de la fila
          row.eachCell((cell, colIndex) => {
            // Verificar si el contenido de la celda cumple con una condición
            // Cambiar el color de fondo de la celda si el contenido incluye "No Puede"
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: colores(cell.value) },
            };
            // Agregar todos los bordes a la celda
            cell.border = {
              top: { style: "thin" },
              left: { style: "thin" },
              bottom: { style: "thin" },
              right: { style: "thin" },
            };
            // cell.dataValidation = {
            //   type: "list",
            //   allowBlank: true,
            //   formulae: [
            //     `
            //     "Alta preferencia,
            //     Puede,pero mejor no,
            //     Preferentemente Evitar,
            //     No puede"`,
            //   ],
            // };
          });
        });

        // Guardar el archivo Excel
        workbook.xlsx
          .writeBuffer()
          .then((buffer) => {
            const blob = new Blob([buffer], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            // Crear un objeto URL para el blob
            const blobURL = URL.createObjectURL(blob);

            // Crear un enlace (link) para descargar el archivo
            const a = document.createElement("a");
            a.href = blobURL;
            a.download = "datos.xlsx";
            document.body.appendChild(a);

            // Simular un clic en el enlace para iniciar la descarga
            a.click();
          })
          .catch((err) => console.error("Error writing excel export", err));
      });
    } catch (error) {
      console.error(
        "Error al descargar el archivo Excel:",
        error.response?.data?.message || error.message
      );
      setError(
        error.response?.data?.error ||
          "Error al descargar el archivo Excel. Inténtalo de nuevo."
      );
    }
  };

  const mostrarNotificacionesSecuenciales = (datos, index) => {
    if (index < datos.length) {
      notifyWanr(
        `Equipo: ${datos[index].Nombre} no encontrado en nuestra base`
      );
      setTimeout(() => {
        mostrarNotificacionesSecuenciales(datos, index + 1);
      }, 500); // tiempo de espera entre notificaciones (en milisegundos)
    }
  };

  const adjuntarArchivo = async (e) => {
    const archivoInput = document.getElementById("archivoInput");
    const archivo = archivoInput.files[0];

    const reader = new FileReader();
    reader.readAsBinaryString(archivo);
    reader.onload = (e) => {
      const data = e.target.result;
      const workbook = XLSX.read(data, { type: "binary" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const parsedData = XLSX.utils.sheet_to_json(sheet);

      try {
        const errores = axios
          .post(`${API_URL}/actualizarEquipos/${idTorneo}`, parsedData)
          .then((erroresThen) => {
            const datos = erroresThen.data;
            // datos.map((dato) =>
            //   notifyWanr(
            //     `Equipo : ${dato.Nombre} no encontrado en nuestra base`
            //   )
            // );
            mostrarNotificacionesSecuenciales(datos, 0);

            // Limpiar el nombre del archivo y el contenido después de enviar
            archivoInput.value = "";
            const fileNameDisplay = document.getElementById(
              "fileNameDisplayTurnos"
            );
            fileNameDisplay.textContent = "";
          });
      } catch (error) {
        console.error(error);
        //Tirar error si no encontro el usuario
      }
    };
  };

  const leerTxt = () => {
    const archivoInput = document.getElementById("archivoInputEquipos");
    const archivo = archivoInput.files[0];

    if (archivo) {
      const lector = new FileReader();

      lector.onload = (e) => {
        const contenido = e.target.result;
        const texto = contenido.replace(/(\r\n|\r)/g, "\n");
        const equipos = [];

        // Separar el texto en líneas utilizando el carácter de salto de línea (\n)
        const lineas = texto.split("\n");
        lineas.map((linea) => {
          const json = { nombre: linea, idTorneo: idTorneo };
          equipos.push(json);
        });

        try {
          const errores = axios
            .post(
              `${API_URL}/equipos?idTorneo=${idTorneo}`,
              { equipos },
              headers
            )
            .then((erroresThen) => {
              const datos = erroresThen.data;
              // datos.map((dato) =>
              //   notifyWanr(
              //     `Equipo : ${dato.Nombre} no encontrado en nuestra base`
              //   )
              // );
              if (datos.length > 0)
                mostrarNotificacionesSecuenciales(errores, 0);
              else notifySuccess("Equipos cargados correctamente");

              // Limpiar el nombre del archivo y el contenido después de enviar
              archivoInput.value = "";
              const fileNameDisplay = document.getElementById(
                "fileNameDisplayEquipos"
              );
              fileNameDisplay.textContent = "";
            });
        } catch (error) {
          console.log(error);
          //Tirar error si no encontro el usuario
        }
      };
      lector.readAsText(archivo);
    }
  };

  return (
    <Modal show={showModalCargaMasiva} onHide={quitar} centered>
      {/* <div className="section-title p-0 mt-3">
        <h3>
          Carga <span>masiva</span>
        </h3>
      </div> */}
      <Modal.Body>
        <div className="row" style={{ paddingBottom: "20px" }}>
          <div className="section-typography" style={{ paddingBottom: "20px" }}>
            <h6>
              Descargar modelo de <span>disponibilidades</span>
            </h6>
          </div>
          <Button
            variant="primary"
            onClick={descargarExcel}
            className="w-75 mx-auto"
          >
            Descargar archivo
          </Button>
        </div>
        <hr className="my-2" /> {/* Línea divisoria */}
        <div className="row" style={{ paddingBottom: "20px" }}>
          <div className="section-typography" style={{ paddingBottom: "20px" }}>
            <h6>
              Carga masiva de <span>disponibilidades</span>
            </h6>
          </div>
          <div className="row w-75 mx-auto">
            <div className="col-sm-9">
              <label
                htmlFor="archivoInput"
                className="btn btn-primary me-2 w-100"
              >
                Adjuntar archivo
              </label>
              <input
                id="archivoInput"
                type="file"
                className="d-none"
                onChange={(e) => {
                  const fileNameDisplayTurnos = document.getElementById(
                    "fileNameDisplayTurnos"
                  );
                  fileNameDisplayTurnos.textContent = e.target.files[0].name;
                }}
              />
              <span id="fileNameDisplayTurnos"></span>
            </div>
            <div className="col-sm-3">
              <button
                type="submit"
                className="btn btn-success"
                onClick={adjuntarArchivo}
              >
                Enviar
              </button>
            </div>
          </div>
        </div>
        <hr className="my-2" /> {/* Línea divisoria */}
        <div className="row">
          <div className="section-typography" style={{ paddingBottom: "20px" }}>
            <h6>
              Carga masiva de <span>equipos</span>
            </h6>
          </div>{" "}
          <div className="row w-75 mx-auto">
            <div className="col-sm-9">
              <label
                htmlFor="archivoInputEquipos"
                className="btn btn-primary me-2 w-100"
              >
                Adjuntar archivo
              </label>
              <input
                id="archivoInputEquipos"
                type="file"
                className="d-none"
                onChange={(e) => {
                  const fileNameDisplay = document.getElementById(
                    "fileNameDisplayEquipos"
                  );
                  fileNameDisplay.textContent = e.target.files[0].name;
                }}
              ></input>
              <span id="fileNameDisplayEquipos"></span>
            </div>
            <div className="col-sm-3">
              <button
                type="submit"
                className="btn btn-success"
                onClick={leerTxt}
              >
                Enviar
              </button>
            </div>
          </div>
        </div>
        {error && <div className="alert alert-danger mt-3">{error}</div>}
      </Modal.Body>
      <Modal.Footer>
        {/* <Button variant="secondary" onClick={quitar}>
          Cancelar
        </Button> */}
      </Modal.Footer>
    </Modal>
  );
};

export default ModalCargaMasiva;
